export default __webpack_public_path__ + "img/adviewer_logo.png";